import { TABLA_DETALLE_POR_CEREAL_LINEA_12 } from '../../../../../config/tables'
import { COLUMNS_DETALLE_POR_CEREAL_LINEA_12, COLUMNS_DETALLE_POR_CEREAL_LINEA_12_TO_PRINT } from './constantesDetallePorCerealLinea12'
import { TablaDetallePorCerealLinea12Service } from '../../../../../models/movimiento/distribucionDetallePorCereal/Tabla_detalle_por_cereal_linea_12'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CEREAL_LINEA_12
    })
    const promiseTablaDetallePorCerealLinea12 = TablaDetallePorCerealLinea12Service.getDataTablaDetallePorCerealLinea12()
    const promiseTablaDetallePorCerealLinea12Total = TablaDetallePorCerealLinea12Service.getDataTablaDetallePorCerealLinea12Total()
    Promise.all([promiseTablaDetallePorCerealLinea12, promiseTablaDetallePorCerealLinea12Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Cereal Sector 1-2',
        dataCombinada,
        COLUMNS_DETALLE_POR_CEREAL_LINEA_12_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CEREAL_LINEA_12,
          data: dataCombinada,
          title: `Distribución Por Cereal Sector 1-2`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CEREAL_LINEA_12
      })
    }
  }
}
